import { gql } from '@apollo/client';

export const FindManySeasons = gql`
  query FindManySeasons {
    findManySeasons {
      id
      name
      startDate
      endDate
    }
  }
`;

export const GET_CURRENT_SEASON = gql`
  query GetCurrentSeason {
    findCurrentSeason {
      id
      name
      startDate
      endDate
    }
  }
`;